// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

// import Vue from 'vue'
import App from './App'
import router from './router'

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);

console.log(2)
import store from './store'
Vue.prototype.store = store
console.log(3)
if (process.env.NODE_ENV === "development") {
  axios.defaults.baseURL = '/apis';
}

Vue.config.productionTip = false

import {copy,go,openw,back} from './assets/changyong.js'
Vue.prototype.copy = copy
Vue.prototype.go = go
Vue.prototype.openw = openw
Vue.prototype.back = back

console.log(4)
// router.beforeEach((to, from, next) => {
//   if(from.path == '/order' && from.to == '/index'){

//   }
//   next()
// })

new Vue({
	el: '#app',
	router,
  store,
	components: {
		App
	},
	template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js